import(/* webpackMode: "eager" */ "/home/deploy/apps/front/src/app/page.tsx");
